<template>
  <div class="main-background filter-page-container">
    <div
      class="filter-page-back-button"
      @click="$emit('setIsChangePage', 'cart')"
    >
      <chevron-left-icon class="back-button-icon" />
      <p class="back-button-text">Назад у кошик</p>
    </div>
    <div
      id="makeOrderContent"
      class="make-order-page-inputs-container"
      :style="{ height: formHeight + 'px' }"
    >
      <p class="make-order-page-main-title">Оформлення замовлення</p>
      <p class="make-order-page-under-main-title">
        Введіть ваші контактні дані
      </p>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="text">Ім'я</label>
        <input
          v-model="customerName"
          class="make-order-input"
          @keyup.enter="handleEnterKey"
          minlength="3"
          maxlength="30"
          type="text"
          id="text"
          placeholder="Іван"
          @focus="isOpenKeyboard(true)"
          @blur="isOpenKeyboard(false)"
        />
        <p
          v-if="isRequiredError && customerName.length < 3"
          class="error-message-text"
        >
          Обов'язкове поле
        </p>
        <p v-if="isShowCyrillicName" class="error-message-text">
          Поле може бути заповнене лише кирилицею
        </p>
      </div>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="text">Прізвище</label>
        <input
          v-model="customerSecondName"
          class="make-order-input"
          @keyup.enter="handleEnterKey"
          @focus="isOpenKeyboard(true)"
          @blur="isOpenKeyboard(false)"
          minlength="3"
          maxlength="30"
          type="text"
          id="text"
          placeholder="Іванов"
        />
        <p
          v-if="isRequiredError && customerSecondName.length < 3"
          class="error-message-text"
        >
          Обов'язкове поле
        </p>
        <p v-if="isShowCyrillicSecondName" class="error-message-text">
          Поле може бути заповнене лише кирилицею
        </p>
      </div>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="text">Номер телефону</label>
        <input
          v-model="onOrderPhoneNumber"
          @keyup.enter="handleEnterKey"
          inputmode="tel"
          @input="validatePhoneNumber"
          class="make-order-input"
          @focus="isOpenKeyboard(true)"
          @blur="isOpenKeyboard(false)"
          type="text"
          id="text"
          placeholder="+380 63 633 63 63"
        />
        <p v-if="!isValidPhoneNumber" class="error-message-text">
          Введіть корректний номер телефону в форматі +380 або 380
        </p>
      </div>
      <p class="make-order-page-title">Адреса доставки</p>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="text">Місто</label>
        <input
          v-model="customerCity"
          @keyup.enter="handleEnterKey"
          @input="debouncedSearch"
          class="make-order-input"
          @focus="isOpenKeyboard(true)"
          @blur="isOpenKeyboard(false)"
          type="text"
          id="textCity"
          placeholder="Введіть місто"
        />
        <p v-if="isRequiredError && !branchCity" class="error-message-text">
          Обов'язкове поле
        </p>
        <div
          v-if="searchedTowns.length && isShowCitys"
          class="searched-order-towns"
        >
          <vue-perfect-scrollbar class="perfect-town-scrollbar">
            <p
              v-for="town of searchedTowns"
              :key="town.uuid_city"
              @click="onClickToCity(town)"
              class="searched-order-town-item"
            >
              {{ town.name }}
            </p>
          </vue-perfect-scrollbar>
        </div>
      </div>
      <div class="make-order-input-container">
        <label class="make-order-input-label">Відділення Нової Пошти</label>
        <input
          v-model="customerPostNumber"
          @keyup.enter="handleEnterKey"
          @focus="setIsShowBranch"
          autocomplete="off"
          class="make-order-input"
          @blur="isOpenKeyboard(false)"
          type="text"
          id="branch-list"
          placeholder="Відділення №"
        />
        <p v-if="isRequiredError && !usedBranch" class="error-message-text">
          Обов'язкове поле
        </p>
        <div :class="`searched-order-posts ${isShowranch ? 'show' : ''}`">
          <input
            id="branch-list"
            @keyup.enter="handleEnterKey"
            type="text"
            placeholder="Пошук"
            v-model="filterPostText"
            @focus="isOpenKeyboard(true)"
            @blur="isOpenKeyboard(false)"
            class="searched-input-post"
          />
          <div v-if="!searchedBranch.length" class="branch-loading-container">
            <loader-spinner class="branch-loading-spinner" />
            <p id="branch-list" class="branch-loading-text">
              Зачекайте, йде завантаження доступних відділень
            </p>
          </div>
          <vue-perfect-scrollbar class="perfect-town-scrollbar">
            <p
              v-for="branch of filteredPostNumbers"
              :key="branch.id"
              @click="onCLickToBranch(branch)"
              class="searched-order-town-item"
            >
              {{ branch.text }}
            </p>
          </vue-perfect-scrollbar>
        </div>
      </div>
    </div>
    <div class="bottom-filter-button-container">
      <div class="final-price-container">
        <p class="final-price">Всього</p>
        <p class="final-price">{{ cartElements.sumTotal }} грн</p>
      </div>
      <div class="error-message-container" v-if="isShowError">
        <p class="error-message-text">
          Під час оформлення замовлення сталася проблема, спробуйте знову
        </p>
      </div>
      <button
        v-if="!isLoadingFetch && !isHideMainButton"
        class="filtration-button"
        @click="setMakeOrder"
      >
        Оформити замовлення
      </button>
      <button
        v-else-if="isLoadingFetch && !isHideMainButton"
        class="filtration-button"
      >
        <loader-spinner class="button-loading-spinner" :LoaderColor="true" />
      </button>
    </div>
  </div>
</template>

<script>
import { ChevronLeftIcon } from "vue-feather-icons";
import debounce from "lodash/debounce";
import { GET_CITYS, GET_ORDER_BRANCH } from "../helpers/requests";
import LoaderSpinner from "../../../components/LoaderSpinner.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "make-order-page",
  components: {
    ChevronLeftIcon,
    LoaderSpinner,
    VuePerfectScrollbar,
  },
  props: {
    addedToCardProducts: {
      type: Array,
      required: true,
    },
    telegram: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      productCounter: 0,
      customerName: "",
      customerSecondName: "",
      customerPostNumber: "",
      onOrderPhoneNumber: "+380",
      customerCity: "",
      filterPostText: "",
      isWrongFormat: false,
      isLoading: true,
      branchCity: null,
      usedBranch: null,
      isShowranch: false,
      searchedTowns: [],
      searchedBranch: [],
      filteredPostNumbers: [],
      resultMakePrder: null,
      isShowError: false,
      isLoadingFetch: false,
      isValidPhoneNumber: true,
      isRequiredError: false,
      formHeight: 0,
      isShowCitys: false,
      isShowCyrillicName: false,
      isShowCyrillicSecondName: false,
      isHideMainButton: false,
    };
  },
  mounted() {
    this.formHeight = window.innerHeight - 220 - 118;
    window.scrollTo(0, 0);
    window.addEventListener("click", (event) => {
      if (this.isShowranch && event.target.id !== "branch-list") {
        this.isShowranch = false;
      }
    });
    setTimeout(() => {
      const { first_name, last_name, phone } = this.getOrderId.customer;
      this.customerName = first_name;
      this.customerSecondName = last_name;
      this.onOrderPhoneNumber = phone;
    }, 100);
    document.body.addEventListener("click", (event) => {
      let target = event.target;
      if (target.id === "textCity") {
        this.isShowCitys = true;
      } else {
        this.isShowCitys = false;
      }
    });
    this.telegram.MainButton.onClick(() => {
      const focusedElement = document.activeElement;
      const inputs = document.querySelectorAll("input");
      for (const input of inputs) {
        if (input.value === "") {
          input.focus();
          break;
        }
      }
      if (
        this.customerName &&
        this.customerSecondName &&
        this.onOrderPhoneNumber &&
        this.customerCity &&
        this.customerPostNumber
      ) {
        focusedElement.blur();
      }
    });
  },
  computed: {
    getOrderId() {
      return this.$store.getters.getOrderId;
    },
    cartElements() {
      return this.$store.getters.getCustomerCart;
    },
  },
  methods: {
    debouncedSearch: debounce(async function() {
      try {
        let data = {
          order_id: this.getOrderId.id,
          q: this.customerCity,
        };
        let result = await GET_CITYS(data);
        this.searchedTowns = result.data;
      } catch (error) {
        console.log(error.message);
      }
    }, 300),
    handleEnterKey() {
      const activeElement = document.activeElement;
      if (activeElement.tagName === "INPUT") {
        activeElement.blur();
        if (this.searchedTowns.length) {
          this.searchedTowns = [];
        }
      }
    },
    isOpenKeyboard(value) {
      if (this.telegram.platform === "tdesktop") {
        return;
      }
      if (value) {
        this.telegram.MainButton.setParams({
          text: "Готово",
          color: "#01bace",
          text_color: "#fff",
        });
        this.telegram.MainButton.show();
        this.isHideMainButton = true;
      } else {
        this.telegram.MainButton.hide();
        this.isHideMainButton = false;
      }
    },
    validatePhoneNumber() {
      const ukrainePhoneRegex = /^(\+?38)?(0\d{9})$/;
      if (this.onOrderPhoneNumber?.length >= 12) {
        this.isValidPhoneNumber = ukrainePhoneRegex.test(
          this.onOrderPhoneNumber
        );
      }
    },
    setIsShowBranch() {
      this.isOpenKeyboard(true);
      if (!this.branchCity) {
        return;
      }
      setTimeout(() => {
        this.isShowranch = true;
      }, 300);
      setTimeout(() => {
        document.querySelector(".searched-input-post").focus();
      }, 800);
    },
    setHawePlusOnNumber(number) {
      if (number.startsWith("+")) {
        return number.slice(1);
      } else {
        return number;
      }
    },
    setMakeOrder() {
      if (this.isShowCyrillicName || this.isShowCyrillicSecondName) {
        return;
      }
      if (!this.isValidPhoneNumber) {
        return;
      }
      if (
        !this.branchCity ||
        !this.usedBranch ||
        this.customerName?.length < 3 ||
        this.customerSecondName?.length < 3 ||
        !this.onOrderPhoneNumber.length
      ) {
        this.isRequiredError = true;
        return;
      }
      if (this.onOrderPhoneNumber.length < 11) {
        this.isValidPhoneNumber = false;
      }
      this.isRequiredError = false;
      this.isLoadingFetch = true;
      let data = {
        order_id: this.getOrderId.id,
        uuid: this.usedBranch.id,
        delivery_phone: this.setHawePlusOnNumber(this.onOrderPhoneNumber),
        delivery_first_name: this.customerName,
        delivery_last_name: this.customerSecondName,
      };
      try {
        let result = this.$store.dispatch("setSaveOrder", JSON.stringify(data));
        result
          .then((value) => (this.resultMakePrder = value.status))
          .catch((error) => (this.resultMakePrder = error));
      } catch (error) {
        console.log(error.message);
      }
    },
    onClickToCity(value) {
      if (!value.uuid_city) {
        this.searchedTowns = [];
        return;
      }
      this.branchCity = value;
      this.customerCity = value.name;
      this.searchedTowns = [];
      this.onSearchCitysBranch();
    },
    onCLickToBranch(value) {
      this.usedBranch = value;
      this.customerPostNumber = value.text;
      this.isShowranch = false;
    },
    async onSearchCitysBranch() {
      if (!this.branchCity) {
        return;
      }
      this.isLoading = true;
      try {
        let data = {
          order_id: this.getOrderId.id,
          uuid_city: this.branchCity.uuid_city,
        };
        let result = await GET_ORDER_BRANCH(data);
        this.searchedBranch = result.data;
      } catch (error) {
        console.log(error.message);
      }
      this.isLoading = false;
    },
    setChangeCounter(value) {
      if (value === "+") {
        this.productCounter += 1;
      } else {
        this.productCounter -= 1;
      }
    },
  },
  watch: {
    customerName(newValue, oldVaue) {
      if (!newValue) {
        this.isShowCyrillicName = false;
        return;
      }
      let reg = /^[\u0400-\u04FF]+$/;
      if (reg.test(newValue)) {
        this.isShowCyrillicName = false;
      } else {
        this.isShowCyrillicName = true;
      }
      let val = oldVaue;
      val;
    },
    customerSecondName(newValue, oldVaue) {
      if (!newValue) {
        this.isShowCyrillicSecondName = false;
        return;
      }
      let reg = /^[\u0400-\u04FF]+$/;
      if (reg.test(newValue)) {
        this.isShowCyrillicSecondName = false;
      } else {
        this.isShowCyrillicSecondName = true;
      }
      let val = oldVaue;
      val;
    },
    customerPostNumber(newValue, oldVaue) {
      let val = oldVaue;
      val;
      this.filterPostText = newValue;
    },
    branchCity(newValue, oldVaue) {
      let val = oldVaue;
      val;
      this.usedBranch = null;
      this.customerPostNumber = "";
      this.searchedBranch = [];
    },
    searchedBranch(newValue, oldVaue) {
      let val = oldVaue;
      val;
      this.filteredPostNumbers = newValue;
    },
    filterPostText(newValue, oldValue) {
      let val = oldValue;
      val;
      if (newValue?.length >= 1) {
        const regex = new RegExp(".*" + newValue + ".*", "i");
        let newArray = this.searchedBranch.filter((post) =>
          regex.test(post.text)
        );
        this.filteredPostNumbers = newArray;
      } else {
        this.filteredPostNumbers = this.searchedBranch;
      }
    },
    resultMakePrder(newValue, oldValue) {
      let val = oldValue;
      val;
      this.isLoadingFetch = false;
      if (newValue === true) {
        this.$emit("setIsChangePage", "success");
      } else {
        this.isShowError = true;
      }
    },
  },
};
</script>

<style scoped>
.main-background {
  background: #fff;
}
.filter-page-back-button {
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  padding: 18px;
  cursor: pointer;
}

.back-button-icon {
  position: absolute;
}

.back-button-text {
  text-align: center;
}

.filter-page-container {
  display: flex;
  flex-direction: column;
}

.bottom-filter-button-container {
  background: #fff;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
  z-index: 100;
}

.filtration-button {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #16abb8;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
}

.return-to-shop {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #fff;
  color: #16abb8;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #16abb8;
}

.final-price-container {
  display: flex;
  justify-content: space-between;
}
.final-price {
  color: #121212;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 5px;
}
.make-order-page-inputs-container {
  padding: 0 16px 5px 16px;
  margin-top: 4px;
  margin-bottom: 10px;
  overflow-y: scroll;
}

.make-order-input-container {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  position: relative;
}
.make-order-input-label {
  color: #707070;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.make-order-input {
  border-radius: 8px;
  border: 1px solid #d2d6db;
  background: #fff;
  color: #707070;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  padding: 10px 15px;
  margin-top: 4px;
  outline-color: #01bace;
}

.make-order-page-title {
  margin-top: 16px;
  color: #121212;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.make-order-page-main-title {
  color: #333;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.make-order-page-under-main-title {
  color: #333;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
}

.searched-order-posts {
  position: fixed;
  width: 100%;
  max-height: 350px;
  padding: 10px;
  left: 0px;
  bottom: 0px;
  z-index: 101;
  background: #fff;
  overflow: hidden;
  transform: translateY(100%);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: all 0.5s ease;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}

.searched-order-posts.show {
  transform: translateY(0);
}

.searched-order-towns {
  position: absolute;
  width: 100%;
  max-height: 150px;
  overflow: hidden;
  background-color: #ffffff;
  border: 1px solid #d2d6db;
  border-radius: 8px;
  padding: 10px 5px;
  bottom: 45px;
}

.searched-order-town-item {
  padding: 10px;
  cursor: pointer;
  color: #707070;
  border-radius: 5px;
  transition: all 0.2s ease;
}

.searched-order-town-item:hover {
  background-color: #01bace;
  color: #fff;
}

.branch-loading-container {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.branch-loading-text {
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  margin-top: 20px;
}
.branch-loading-spinner {
  margin: auto 0;
}

.button-loading-spinner {
  margin: auto;
}
.perfect-town-scrollbar {
  height: 400px;
}

.searched-input-post {
  border-radius: 8px;
  border: 1px solid #d2d6db;
  background: #fff;
  color: #707070;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  padding: 10px 15px;
  margin-top: 4px;
  outline-color: #01bace;
  width: 100%;
  margin-bottom: 10px;
}

.error-message-container {
  padding: 5px 10px;
}

.error-message-text {
  font-size: 12px;
  font-weight: 400;
  color: red;
}
</style>
